<div class="page-body">
  <div class="row">
    <div class="col-sm-12">
      <app-card
        [advanceButton]="true"
        [advancedButtons]="specialButton"
        [dropdownButton]="dropdownButton"
        (outputDropdownButton)="export($event)"
        [cardOptionBtnValue]="'global.add_btn_text'|translate "
        (outputButtonAdvance)="calFunction($event)"
        [title]="'global.overview'|translate">
        <app-grid [grid]="grid" (sendParameters)="setParams($event)"></app-grid>
        <button class="btn btn-primary ripple light pull-right my-3" (click)="goToArchive()"
                type="button">{{'global.view_archive'|translate}}</button>
      </app-card>
    </div>
  </div>
</div>
<ng-template #priceTemp let-row="row" let-value="value" let-column="column">
  {{((row.dealerPrice) ? row.dealerPrice : row.customerPrice)| BackofficeCurrency}}
</ng-template>
<ng-template #customerPriceTemp let-row="row" let-value="value" let-column="column">
  {{row.customerPrice| BackofficeCurrency}}
</ng-template>

<app-modal-basic #deleteModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_delete_title' | translate:{entity: 'Product'} }}</h4>
    <button type="button" class="close basic-close" (click)="deleteModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_delete_body' | translate}}: <span [innerHTML]="productName"></span> ?</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="deleteModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light"
            (click)="softDelete()">{{'global.actions.delete'|translate}}</button>
  </div>
</app-modal-basic>
<app-modal-basic #importModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{'admin.product.import.title' | translate}}</h4>
    <button type="button" class="close basic-close" (click)="cancelUpload()" [disabled]="this.isUploading">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'admin.product.import.body_message' | translate}}</p>
    <div class="form-group row">
      <div class="form-group col-md-12">
        <label>{{ 'global.import_file' | translate}} *</label>
        <label class="custom-file">
          <input type="file" ng2FileSelect #uploadEl [uploader]="uploader" class="custom-file-input" id="uploaderFile"
                 (change)="onFileSelected()"
                 accept=".xlsx, .xls, .csv">
          <span class="custom-file-control-upload"
                *ngIf="uploader.queue.length==0">{{"global.choose_file"|translate}}</span>
          <span class="custom-file-control-upload"
                *ngIf="uploader.queue.length>0">{{"global.change_file"|translate}}</span>
          <span
            class="custom-file-control">{{(uploader.queue.length > 0) ? uploader.queue[uploader.queue.length - 1].file.name : ''}}</span>
        </label>
      </div>
    </div>
    <div class="row">
      <!-- Loading Style -->
      <div class="preloader3 loader-block mx-auto" *ngIf="isUploading">
        <div class="circ1 loader-success"></div>
        <div class="circ2 loader-success"></div>
        <div class="circ3 loader-success"></div>
      </div>
    </div>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="cancelUpload()" [disabled]="this.isUploading">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light"
            (click)="uploadFile()" [disabled]="this.isUploading">{{'global.import'|translate}}</button>
  </div>
</app-modal-basic>
<a #downloadLink href="" download style="display: none"></a>
<app-modal-basic [dialogClass]="'modal-lg'" #importResultModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{'admin.product.import.title_result' | translate}}</h4>
    <button type="button" class="close basic-close" (click)="importResultModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <ul style="list-style-type: disc" class="ps-3">
      <li *ngFor="let message of messages">{{message}}</li>
    </ul>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-primary ripple light"
            (click)="importResultModal.hide()">{{'global.ok'|translate}}</button>
  </div>
</app-modal-basic>
